import { CargaCumplimiento, CargaCumplimientoFiltro } from '../../model/cumplimiento/carga-cumplimiento';

/**
 * Puerto Abstracto: CargaCumplimientoRepository
 *
 * Define el contrato para consulta de resultado de carga masiva de cumplimientos Sin OC.
 *
 * @legacy AdminCumplimientoHandler.consultaCargaCumplimiento()
 * @author Sura - Migración GWT a Angular
 */
export abstract class CargaCumplimientoRepository {

  /**
   * Consulta los registros de carga masiva filtrando por fechas y estados.
   *
   * @param filtro criterios: fechaInicial, fechaFinal, estados (PENDIENTE/PROCESADO/ERROR)
   * @returns Promesa con lista de registros de TPSC_CARGA_CUMPL_SINOC
   */
  abstract consultarResultado(filtro: CargaCumplimientoFiltro): Promise<CargaCumplimiento[]>;
}
